<template>
	<div class="link">

		<el-input
		ref="input"
		class="input-sigarus-link"
		@focus="$emit('focus')"
		@blur="$emit('blur')"
		v-model="model"
		v-bind="{...$attrs, ...$props}"/>

		<el-button
		size="mini"
		icon="el-icon-link"
		@click="goLink()"/>
	</div>
</template>

<script>
	export default {
		name: 'InputSigarusLink',
		props: {
			value: {
				default: ''
			}
		},
		data() {
			return {
				attrs: null
			}
		},
		computed: {

			model: {

				get () { return this.value },

				set (val) { this.$emit('input', val) }
			}
		},
		mounted() {
			this.attrs = JSON.parse(JSON.stringify(this.$attrs))
		},
		methods: {

			$render (val) {
				return this.attrs.readonly ? `<a href="${val}" target="_blank">${val}</a>` : val
			},

			focus () {
				setTimeout(() => this.$refs.input.focus(), 200)
			},

			select () {
				setTimeout(() => this.$refs.input.select(), 200)
			},

			goLink() {
				this.openwindow(this.value)
			}
		}
	}
</script>

<style lang="scss">
	.link {
		display: flex;
		button {
			flex-shrink: 1;
		}
	}
</style>
